import { WebEDIErrorsService } from './webediErrors';

/**
 * Kept out of `./index` so that `hooks` and `useNavigableAnnotations` can reach the singleton
 * without importing the barrel that re-exports them — that was a real `index -> hooks -> index`
 * cycle, survivable only because the hooks read the singleton at call time rather than at module
 * init. `./index` still re-exports this, so consumers keep importing from `services/webediErrors`.
 */
export const WebEDIErrorsServiceSingleton = new WebEDIErrorsService();
